<template>
   <div class="all_form_block" data-name="info">
      <div class="block">
         <div class="name_tools" id="basic-info">{{ $store.getters.cv_t('basic_info') }}</div>
         <div class="all_form">
            <div class="inp_info">
               <div class="div_relative active">
                  <span v-on:click="$parent.correctLabel($event)">{{ $store.getters.cv_t('birthday') }}</span>
                  <datepicker
                      name="date"
                      :required="true"
                      :clear-button="true"
                      :format="'dd.MM.yyyy'"
                      :minimumView="'day'"
                      :maximumView="'year'"
                      :initialView="'year'"
                      :language="$parent.langDatepicker($store.getters.cv_locale)"
                      :disabledDates="disabledDates"
                      v-model="$store.state.cv.date"
                  ></datepicker>
               </div>
               <div class="div_relative">
                  <span v-on:click="$parent.correctLabel($event)">{{ $store.getters.cv_t('name') }}</span>
                  <input
                      name="name"
                      v-model.trim="$store.state.cv.name"
                      required
                      type="text"
                      v-validate="'required|min:3|max:255'"
                      :class="errors.first('name') ? 'invalid' : ''"
                      v-on:input="$parent.correctLabel($event)"
                      v-on:keyup.tab="$parent.correctLabel($event)"
                      v-on:click="$parent.correctLabel($event)"
                  >
               </div>
               <div class="div_relative">
                  <span v-on:click="$parent.correctLabel($event)">{{ $store.getters.cv_t('surname') }}</span>
                  <input
                      name="surname"
                      v-model.trim="$store.state.cv.surname"
                      required
                      type="text"
                      v-validate="'required|min:3|max:255'"
                      :class="errors.first('surname') ? 'invalid' : ''"
                      v-on:input="$parent.correctLabel($event)"
                      v-on:keyup.tab="$parent.correctLabel($event)"
                      v-on:click="$parent.correctLabel($event)"
                  >
               </div>
               <div class="div_relative">
                  <span v-on:click="$parent.correctLabel($event)">{{ $store.getters.cv_t('career_objective') }}</span>
                  <textarea
                      name="career_objective"
                      v-model.trim="$store.state.cv.career_objective"
                      v-validate="'required|min:3|max:255'"
                      :class="errors.first('career_objective') ? 'invalid' : ''"
                      v-on:input="$parent.correctLabel($event)"
                      v-on:keyup.tab="$parent.correctLabel($event)"
                      v-on:click="$parent.correctLabel($event)"
                  ></textarea>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
  import Datepicker from 'vuejs-datepicker';
  export default {
    components: {
      Datepicker
    },
    data() {
      return {
        disabledDates: {
          from: new Date()
        }
      };
    },
    watch:{
      '$store.state.cv.date'(newVal){
        this.$store.dispatch('sendMailchimpApi');
      },
      '$store.state.cv.name'(newVal){
        if(newVal.length > 2){
          this.$store.dispatch('sendMailchimpApi');
        }
      },
      '$store.state.cv.surname'(newVal){
        if(newVal.length > 2){
          this.$store.dispatch('sendMailchimpApi');
        }
      }
    },
    mounted() {
    },
    methods: {
      updateData(key, e) {
        this.$store.commit("cv", {key: key, val: e.target.value});
      }
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools-components/BasicInfo.vue